import { useAppContext } from '../../../../Services/AppContext';
import { useState } from 'react';
import { useEffectAsync } from '../../../../helpers';
import apiClient from '../../../../Services/ApiClient';
import { gql } from '@apollo/client';
import * as React from 'react';
import SearchWorkplaceResultOld from './SearchWorkplaceResultOld';
import SearchWorkplaceNoResults from '../SearchWorkplace/SearchWorkplaceNoResults';
import Search from "../../../BaseModule/Components/Search/Search";

interface Props {
	linkSelect: string;
	gqlParams: {};
	hideEmptySearch: boolean;
}

const SearchWorkplaceOld: React.FC<Props> = ({linkSelect, gqlParams, hideEmptySearch}) => {
	const { translation } = useAppContext();
	const [items, setItems] = useState<{id: string, name: string}[]|null>(null);
	const [fulltext, setFulltext] = useState<string>('');

	const searchQuery = gql`
		query Workplaces($fulltext: String!, $patientId: UUID!, $type: String) {
			workplaces(fulltext: $fulltext, patientId: $patientId, type: $type) {
				data {
					id
					name
				}
			}
		}
	`;

	const handleSearch = (text: string) => {
		setFulltext(text);
	};

	const variables = { fulltext, ...gqlParams };

	// @ts-ignore
	useEffectAsync(async () => {
		if (!hideEmptySearch || fulltext.length > 2) {
			const result = await apiClient.graphql({
				query: searchQuery,
				variables: variables,
				fetchPolicy: 'network-only',
			});
			setItems(result?.data?.workplaces?.data || []);
		} else {
			setItems(null);
		}
	}, [fulltext, hideEmptySearch]);

	const itemsContent = items?.length ? (
		items.map((item, index) => (
			<SearchWorkplaceResultOld
				key={index}
				workplace={item}
				linkSelect={linkSelect}
			/>
		))
	) : (
		<SearchWorkplaceNoResults />
	);

	return (
		<Search
			resultContent={items !== null ? itemsContent : null}
			handleSearch={handleSearch}
			placeholder={
				translation['base.shared.enterWorkplaceNameWhichYouAreLookingFor']
			}
		/>
	);
};

export default SearchWorkplaceOld;